import React from "react";
import { Instagram } from "lucide-react";
import { VIBER_URL, WHATSAPP_URL, INSTAGRAM_URL } from "../data/socials";

export const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z" />
  </svg>
);

export const ViberIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M11.4.8C9.5.8 5.6 1 3.4 3 2 4.4 1.5 6.5 1.4 9.1c0 2.6-.1 7.4 4.5 8.7v2c0 .7.4.9.7.9.2 0 .4-.1.6-.3l1.9-2.1c1.7.1 2.9.1 3.3 0 .5 0 4.4-.2 6.6-2.2 1.4-1.4 1.9-3.5 2-6.1v-.4c0-1.3-.1-4.6-2-6.4C16.8 1 12.9.8 11.4.8zm.2 1.6c1.8 0 4.9.3 6.3 1.6 1.5 1.4 1.5 4.3 1.5 5.4v.3c0 2.3-.5 4-1.5 5-1.7 1.6-5.2 1.7-5.6 1.8-.4 0-1.8.1-3.5-.1l-1.7 1.9v-2.3l-.6-.2C2.9 15 3 11 3 9.2c0-2.3.5-4 1.5-5 1.7-1.6 5.2-1.7 5.6-1.8h1.5zm.3 2.4c-.2 0-.4.2-.4.4s.2.4.4.4c1.1 0 2 .4 2.7 1.1.7.7 1 1.7 1 2.8 0 .2.2.4.4.4s.4-.2.4-.4c0-1.3-.4-2.5-1.3-3.4-.8-.8-2-1.3-3.2-1.3zm-3.4.4c-.2 0-.4 0-.6.1-.5.2-1 .7-1.2 1.3-.2.5-.1 1 .1 1.4l.1.1c.5 1 1.2 2 2 2.9 1 1.2 2.3 2.2 3.7 3l.1.1c.4.2.9.3 1.4.1.6-.2 1.1-.7 1.3-1.2.1-.3.1-.6-.1-.8-.6-.5-1.2-.9-1.9-1.3-.4-.2-.8-.1-1 .2l-.4.5c-.2.2-.5.2-.5.2s-2.8-1.2-3.5-4c0 0 0-.3.2-.5l.5-.4c.3-.2.4-.7.2-1-.4-.7-.8-1.3-1.3-1.9-.1-.2-.3-.3-.5-.3zm3.7 1.2c-.2 0-.4.2-.4.4s.2.4.4.4c.6 0 1.1.2 1.5.6.4.4.5.9.5 1.5 0 .2.2.4.4.4s.4-.2.4-.4c0-.8-.2-1.5-.8-2.1-.5-.5-1.2-.8-2-.8z" />
  </svg>
);

const SocialFloat = () => (
  <div data-testid="social-float" className="fixed bottom-24 right-6 z-50 flex flex-col gap-3">
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="float-whatsapp-btn"
      aria-label="WhatsApp"
      className="w-12 h-12 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/30 hover:scale-110 transition-transform"
    >
      <WhatsAppIcon className="w-6 h-6" />
    </a>
    <a
      href={VIBER_URL}
      data-testid="float-viber-btn"
      aria-label="Viber"
      className="w-12 h-12 flex items-center justify-center rounded-full bg-[#7360F2] text-white shadow-lg shadow-black/30 hover:scale-110 transition-transform"
    >
      <ViberIcon className="w-6 h-6" />
    </a>
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="float-instagram-btn"
      aria-label="Instagram"
      className="w-12 h-12 flex items-center justify-center rounded-full text-white shadow-lg shadow-black/30 hover:scale-110 transition-transform"
      style={{ background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)" }}
    >
      <Instagram className="w-5 h-5" strokeWidth={1.8} />
    </a>
  </div>
);

export default SocialFloat;
